var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gl-display-flex"},[_c('gl-truncate',{staticClass:"gl-min-w-0",attrs:{"text":_vm.firstItemText,"data-qa-selector":_vm.qaSelector}}),_vm._v(" "),(_vm.additionalItemsCount)?_c('span',{staticClass:"gl-ml-2"},[_vm._v("\n    "+_vm._s(_vm.n__('+%d more', '+%d more', _vm.additionalItemsCount))+"\n  ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }